import * as React from 'react';
import classNames from 'classnames';
import Slider from 'rc-slider';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel, ApronBackSplashModel, ApronBackSplashDefaultModel, SURGEEDGE_BACKSPLASH, LEFT_RIGHT, MinMaxModel } from 'franke-trough-dependencies';
import { ElementPosition, ElementPositionState } from '../Utils';
import { DebounceInput } from 'react-debounce-input';
import { filter as _filter } from 'lodash';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ApronBacksplash.messages';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface SurgeEdgeBacksplashProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: any;
}

export interface SurgeEdgeBacksplashState {
  backsplashHeight?: ApronBackSplashModel['backsplashHeight'];
  slideHeight?: number;
  heightError: boolean;
}

interface DispatchConfigurationProps {
  backsplashHeight?: ApronBackSplashModel['backsplashHeight'];
  surgeEdgeOrBackSplash: ApronBackSplashModel['surgeEdgeOrBackSplash'];
  positionOfEdgeOrBacksplash?: ApronBackSplashModel['positionOfEdgeOrBacksplash'];
}

const SurgeEdgeLabel: React.SFC<{value: SURGEEDGE_BACKSPLASH}> = (props) => {
  switch (props.value) {
    case 'without':
      return (<span><FormattedMessage {...MESSAGES.surgeEdgeLabelWithout} /></span>);
    case 'withSurgeEdge':
      return (<span><FormattedMessage {...MESSAGES.surgeEdgeLabelWith} /></span>);
    case 'withBackSplash':
      return (<span><FormattedMessage {...MESSAGES.surgeEdgeLabelWithBackSplash} /></span>);
    default:
      return null;
  }  
};

export class SurgeEdgeBacksplashPartial extends React.Component<SurgeEdgeBacksplashProps, SurgeEdgeBacksplashState> {
  constructor(props: SurgeEdgeBacksplashProps) {
    super(props);
    this.state = {
      heightError: false,
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSlide = this.handleSlide.bind(this);
    this.handleSlideAfterChange = this.handleSlideAfterChange.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  componentDidMount() {
    if (!this.backsplashHeight) {
      return;
    }

    this.setState({
      backsplashHeight: this.backsplashHeight || (this.backsplashHeightDefaults && this.backsplashHeightDefaults.min),
      slideHeight: this.backsplashHeight || (this.backsplashHeightDefaults && this.backsplashHeightDefaults.min),
    });
  }

  componentDidUpdate(prevProps: SurgeEdgeBacksplashProps, prevState: SurgeEdgeBacksplashState) {
    const widthFromStateHasChanged = this.state.backsplashHeight !== prevState.backsplashHeight ? true : false;
    const widthIsDifferentThenfromApi = this.state.backsplashHeight !== this.backsplashHeight;

    if (!this.state.heightError && widthFromStateHasChanged && widthIsDifferentThenfromApi) {
      this.dispatchConfiguration({
        backsplashHeight: this.state.backsplashHeight,
        positionOfEdgeOrBacksplash: this.positionOfEdgeOrBacksplash,
        surgeEdgeOrBackSplash: 'withBackSplash',
      });
    }

    const configuration = this.props.configuration.result;

    const prevConfiguration = prevProps.configuration.result;

    if (
      (configuration && prevConfiguration) && 
      (configuration.updated_at !== prevConfiguration.updated_at)  
    ) {
      if (!this.backsplashHeight) { return; }
      this.setState({
        backsplashHeight: this.backsplashHeight || (this.backsplashHeightDefaults && this.backsplashHeightDefaults.min),
      });
      if (this.backsplashHeight !== this.state.slideHeight) {
        this.setState({
          slideHeight: this.backsplashHeight || (this.backsplashHeightDefaults && this.backsplashHeightDefaults.min),
        });
      }
    }
  }

  public render() {
    const { slideHeight, heightError } = this.state;
    const backsplashHeight = this.state.backsplashHeight;
    return (
      <div className="partial-surge-edge-backsplash position-relative pb-4">
        {this.surgeEdgeDefaults && this.surgeEdgeDefaults.values.map((value, index) => {
          const key = `surge_edge_backsplash_key_${index}`;
          return (
            <div key={key} className="col-12">
              <label className={classNames({disabled: this.disabled})}>
                <SurgeEdgeLabel value={value} />
                <input 
                  type="radio" 
                  name="surgeEdgeOrBackSplash"
                  checked={this.surgeEdgeOrBackSplash === value}
                  value={value}
                  disabled={this.disabled}
                  onChange={this.handleRadioChange}
                />
                <span className="checkmark" />
              </label>
              {(
                (this.surgeEdgeOrBackSplash === 'withBackSplash' && value === 'withBackSplash') || 
                (this.surgeEdgeOrBackSplash === 'withSurgeEdge' && value === 'withSurgeEdge')
              ) && (
                <div className="row">
                  <div className="col-11 offset-1">
                    <div className="row">
                      <div className="col-12">
                        <label>
                          <FormattedMessage {...MESSAGES.surgeEdgeLabelWithBackSplashBack} />
                          <input type="radio" checked={true} readOnly={true} />
                          <span className="checkmark" />
                        </label>
                      </div>
                      {this.positionDefaults && (this.positionOfEdgeOrBacksplash || this.positionOfEdgeOrBacksplash === null) && (
                        <ElementPosition 
                          defaults={this.positionDefaults}
                          onChange={this.handleCheckboxChange}
                          selected={this.positionOfEdgeOrBacksplash || []}
                          disabled={this.disabled}
                        />
                      )}
                      {value === 'withBackSplash' && this.backsplashHeightDefaults && (
                        <div className="col-12 p-0">
                          <label className="small mb-2 mt-2 d-block">
                            <FormattedMessage {...MESSAGES.surgeEdgeLabelWithBackSplashBackHeight} />
                            {heightError && (
                              <span className="info-icon" id="UncontrolledTooltipExample">
                                <FontAwesomeIcon icon={faInfo} />
                                <UncontrolledTooltip placement="right" target="UncontrolledTooltipExample">
                                  <FormattedMessage {...MESSAGES.apronHeightError} />
                                </UncontrolledTooltip>
                              </span>
                            )}
                          </label>
                          <DebounceInput
                            type="number"
                            min={this.backsplashHeightDefaults.min}
                            max={this.backsplashHeightDefaults.max}
                            className="form-control"
                            onChange={this.handleInputChange}
                            value={backsplashHeight ? backsplashHeight : 0}
                            disabled={this.disabled}
                            debounceTimeout={500}
                          />
                          <div className="row pt-2">
                            <div className="col-2 text-left">
                              {this.backsplashHeightDefaults.min}
                            </div>
                            <div className="col-8 pt-1">
                              <Slider
                                min={this.backsplashHeightDefaults.min}
                                max={this.backsplashHeightDefaults.max}
                                value={slideHeight}
                                disabled={this.disabled}
                                onChange={this.handleSlide}
                                onAfterChange={this.handleSlideAfterChange}
                              />
                            </div>
                            <div className="col-2 text-right">
                              {this.backsplashHeightDefaults.max}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  private get apronBackSplash(): ApronBackSplashModel | null | undefined {
    const {
      configuration
    } = this.props;
    return configuration.result && 
      configuration.result.apronBackSplash;
  }

  private get apronBackSplashDefaults(): ApronBackSplashDefaultModel | null | undefined {
    const {
      configuration
    } = this.props;
    return configuration.result && 
      configuration.result.defaults &&
      configuration.result.defaults.apronBackSplash;
  }

  private get backsplashHeight(): ApronBackSplashModel['backsplashHeight'] | undefined {
    return this.apronBackSplash &&
      this.apronBackSplash.backsplashHeight ?
        this.apronBackSplash.backsplashHeight : undefined;
  }

  private get backsplashHeightDefaults(): MinMaxModel | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result &&
      configuration.result.defaults && 
      configuration.result.defaults.apronBackSplash.backsplashHeight &&
      configuration.result.defaults.apronBackSplash.backsplashHeight.values;
  }

  private get disabled(): boolean {
    return !isConfigurationEditable();
  }

  private dispatchConfiguration(props: DispatchConfigurationProps) {
    const configuration = this.props.configuration && this.props.configuration.result;
    
    if (!configuration) { return; }
    const { apronBackSplash } = configuration;
    
    if (!apronBackSplash || props.positionOfEdgeOrBacksplash === undefined) { 
      return; 
    }
    
    const data: ApronBackSplashModel = apronBackSplash;
    data.backsplashHeight = props.backsplashHeight || null;
    data.surgeEdgeOrBackSplash = props.surgeEdgeOrBackSplash;
    data.positionOfEdgeOrBacksplash = props.positionOfEdgeOrBacksplash;
    
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${configuration && configuration.id}`,
        options: {
          method: 'PATCH',
          data: {apronBackSplash: data}
        },
      },
      true,
    ));
  }

  private handleCheckboxChange(selected: ElementPositionState['selected']) {
    if (!this.surgeEdgeOrBackSplash) { return; }
    
    let positions = this.positionOfEdgeOrBacksplash || [];

    (Object.keys(selected) as (keyof ElementPositionState['selected'])[]).map((key: LEFT_RIGHT) => {
      const index = positions.indexOf(key);
      const hasKey = index > -1 ? true : false;
      
      if (selected[key] === true && !hasKey) {
        positions.push(key);
      }
      if (selected[key] === false && hasKey) {        
        let newPositions = _filter(positions, e => e !== (key as string));
        positions = newPositions;
      }
    });

    const positionOfEdgeOrBacksplash = positions && positions.length === 0 ? null : positions;
    let backsplashHeight: ApronBackSplashModel['backsplashHeight'] = null;
    
    this.dispatchConfiguration({
      backsplashHeight: this.state.backsplashHeight,
      positionOfEdgeOrBacksplash,
      surgeEdgeOrBackSplash: this.surgeEdgeOrBackSplash,
    });

    if (this.surgeEdgeOrBackSplash === 'withBackSplash') {
      backsplashHeight = this.backsplashHeightDefaults && this.backsplashHeightDefaults.min || null;
      this.setState({
        backsplashHeight,
      });
    }
  }

  private handleInputChange(event: React.SyntheticEvent<HTMLInputElement>) {
    if (!this.surgeEdgeOrBackSplash) {
      return;
    }

    const target = event.target as HTMLInputElement;
    const value = Math.round(Number(target.value));
    const isValid = this.backsplashHeightDefaults ? this.validateMinMax(value, this.backsplashHeightDefaults) : false;
    
    if (target.value.length > 0) {
      this.setState({
        backsplashHeight: value,
        slideHeight: isValid && this.state.slideHeight !== value ? value : this.state.slideHeight,
        heightError: !isValid,
      });
    }
  }

  private handleRadioChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    const value = target.value as SURGEEDGE_BACKSPLASH;
    let backsplashHeight: ApronBackSplashModel['backsplashHeight'] = null;
    if (value === 'withBackSplash') {
      backsplashHeight = this.backsplashHeightDefaults && this.backsplashHeightDefaults.min || null;
      this.setState({
        backsplashHeight,
      });
    }

    this.dispatchConfiguration({
      backsplashHeight,
      positionOfEdgeOrBacksplash: null,
      surgeEdgeOrBackSplash: value,
    });
  }

  private handleSlide(value: number) {
    value = Math.round(value);
    const isValid = this.backsplashHeightDefaults ? this.validateMinMax(value, this.backsplashHeightDefaults) : false;

    this.setState({
      slideHeight: value,
      heightError: !isValid,
    });
  }

  private handleSlideAfterChange(value: number) {
    value = Math.round(value);
    if (!this.surgeEdgeOrBackSplash) {
      return;
    }
    this.setState({
      backsplashHeight: this.state.backsplashHeight !== value ? value : this.state.backsplashHeight,
    });
  }

  private get surgeEdgeDefaults(): ApronBackSplashDefaultModel['surgeEdgeOrBackSplash'] | null | undefined {
    return this.apronBackSplashDefaults && 
    this.apronBackSplashDefaults.surgeEdgeOrBackSplash;
  }

  private get surgeEdgeOrBackSplash(): ApronBackSplashModel['surgeEdgeOrBackSplash'] | undefined {
    return this.apronBackSplash && 
    this.apronBackSplash !== null ? 
      this.apronBackSplash.surgeEdgeOrBackSplash : undefined;
  }

  private get positionDefaults(): ApronBackSplashDefaultModel['positionOfEdgeOrBacksplash'] | null | undefined {
    return this.apronBackSplashDefaults && 
    this.apronBackSplashDefaults.positionOfEdgeOrBacksplash;
  }
  
  private get positionOfEdgeOrBacksplash(): ApronBackSplashModel['positionOfEdgeOrBacksplash'] | undefined {
    return this.apronBackSplash && 
    this.apronBackSplash !== null ? 
      this.apronBackSplash.positionOfEdgeOrBacksplash : undefined;
  }

  private validateMinMax(value: number, values: MinMaxModel): boolean {
    if (value > values.max || value < values.min) {
      return false;
    }
    return true;
  }
}

export const SurgeEdgeBacksplash = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(SurgeEdgeBacksplashPartial);

export default SurgeEdgeBacksplash;